import Rellax from 'rellax';

class ParallaxMove {
  constructor() {
    const wrap = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if (wrap) {
      wrap.forEach((element) => {
        new Rellax(element, {
          callback: (positions) => {
            if (element.dataset.id === '0') {
              element.style.top = `${-(positions.y)}px`;
            } else if (element.dataset.id === '1') {
              element.style.top = `${-((positions.y / 2) - 312)}px`;
            } else if (element.dataset.id === '2') {
              element.style.top = `${-((positions.y / 2) - 300)}px`;
            } else if (element.dataset.id === '3') {
              element.style.top = `${-((positions.y / 2) + 240)}px`;
            } else {
              element.style.top = `${-((positions.y / 2) + 140)}px`;
            }
          },
        });
      });
    }
  }
}

export default ParallaxMove;



// WEBPACK FOOTER //
// ./base/script/parallax.js